import { Close } from "@carbon/icons-react";
import { SaveAlt } from "@mui/icons-material";
import {
  Button,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { useTranslation } from "react-i18next";

import FallbackComponent from "../../../../../components/fallbackComponent/FallbackComponent";
import { InboundDeliveryDocumentFragment } from "../../../../../models/autogenerated-deliveryService-gql/graphql";

interface DetailsDocumentsTabProps {
  documents: InboundDeliveryDocumentFragment[];
}

const DetailsDocumentsTab = (props: DetailsDocumentsTabProps) => {
  const { t } = useTranslation();
  const { documents } = props;

  if (documents.length === 0)
    return (
      <FallbackComponent
        middleIcon={<Close size={32} />}
        text={t("noDocumentsExist")}
      />
    );

  return (
    <div>
      <List>
        {documents.map((document, index) => (
          <ListItem key={index}>
            <ListItemIcon>
              <Button href={document.url || undefined}>
                <SaveAlt />
              </Button>
            </ListItemIcon>
            <ListItemText
              primary={`${document.name} - ${t(document.type || "")}`}
            />
          </ListItem>
        ))}
      </List>
    </div>
  );
};

export default DetailsDocumentsTab;
